import dayjs from "dayjs";
import { Notice } from "@/common/types/Notice";
import { request } from "@/common/api";
import { Buttons } from "@/components/atoms/Buttons";
import { useQuery } from "@tanstack/react-query";
import { BoardDetail } from "@/components/molecules/BoardDetail";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { useRecoilValue } from "recoil";
import { GET_DETAIL_NOTICE } from "@/common/querykeys";
import { useNavigate, useParams } from "react-router";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";
import {
  guardianUserState,
  loginTypeState,
  studentUserState,
} from "@/common/states/user";

export const NoticeDetailPage = () => {
  /** 📍 URL Parameter Access */
  const { id } = useParams();

  /** 🛣️ Navigation Capability Acquisition */
  const navigate = useNavigate();

  /** 📦 State Store */
  const loginType = useRecoilValue(loginTypeState);
  const studentInfo = useRecoilValue(studentUserState);
  const guardianInfo = useRecoilValue(guardianUserState);

  /** 📡 API Layer */
  // 특정 이벤트 및 공지 글 세부 데이터 조회
  const { data: noticeContent } = useQuery({
    queryKey: [GET_DETAIL_NOTICE, id, loginType],
    queryFn: async () => {
      const userId = loginType === "student" ? studentInfo.id : guardianInfo.id;

      return await request<Notice>({
        method: "GET",
        url: `/notice/${id}`,
        params: {
          userId,
        },
      });
    },
  });

  return (
    <MainTemplate
      nav={false}
      subPage={false}
      menuBtn={false}
      buttonLeft={
        <Buttons
          type="button"
          size="headerTextIcon"
          layout="text"
          color="bright100"
          icon={<IconArrow />}
          label="목록"
          onClick={() => navigate(-1)}
        />
      }
      pageTitle="게시글 보기"
    >
      <BoardDetail
        category={noticeContent?.type === "event" ? "이벤트" : "공지사항"}
        title={noticeContent?.title || "제목없음"}
        content={noticeContent?.content}
        date={
          noticeContent?.createdAt
            ? dayjs(noticeContent?.createdAt).format("YYYY-MM-DD HH:mm:ss")
            : ""
        }
      />
    </MainTemplate>
  );
};
